<script>
    import {tick} from 'svelte';

    import {getTimestamp, formatTimestamp} from '../Utilities/time_format';
    import {session} from '../Utilities/Session.svelte';
    import FormModal from '../Forms/FormModal.svelte';
    import NoteTags from './NoteTags.svelte';
    import {confirm} from './Confirmation.svelte';
    import {clean} from '../Utilities/Cleaner.svelte';
    import {userMap} from '../Utilities/Session.svelte';


    import TinyMCEField from '../Forms/CustomFields/tinymceField.svelte';

    export let assessment;
    export let section, page;
    export let hidden;

    let el;

    let tags = [];
    let showFormModal;
    let form;

    let mce_opts = {
        toolbar: "undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
        plugins: "lists",
        menubar: false
    }

    function editNote(note) {
        showFormModal = {
            fields: [{
                name: "tags",
                type: "custom",
                component: NoteTags,
                componentProps: {
                    comment_tags: [...(assessment.assessment_type_data.comment_tags || []), ...assessment.comment_tags.tags]
                }
            },{
                name: "note",
                label: "Note",
                type: "tinymce",
                mce_opts,
                required: true
            }],
            title: "Edit Note",
            data: note,
            showDelete: true,
            cancelAction: () => showFormModal = undefined,
            saveAction: (note) => {
                assessment.model.saveNotepadNote(note);
                showFormModal = undefined
            },
            deleteAction: () => {
                confirm("Are you sure you want to delete this note?").then(() => {
                    assessment.model.deleteNotepadNote(note);
                    showFormModal = undefined
                }).catch(err => {});
            }
        }
    }

    function submitNote(evt) {
        let note_text = form.note.value;

        if (!note_text) return;

        let note_tags = tags;

        assessment.model.addNotepadNote(section, page, note_text, note_tags);

        //reset form
        tags = [];
        form.reset();
        form.note.focus();
    }

    function handleEnter(evt) {
        if (evt.keyCode == 13) {
            if (evt.altKey) {
                evt.target.value += "\r\n";
            } else {
                submitNote({
                    target: evt.target.form
                });
                evt.preventDefault();
                return false;
            }
        }
    }

    async function updateScroll() {
        await tick();
        el.scrollTop = el.scrollHeight;
    }

    $: updateScroll(assessment);
</script>

<div class="layout">
    <span class="heading">Notes</span>
    <div class="notes" bind:this={el}>
    {#if assessment.notepad[section.section_id] && assessment.notepad[section.section_id].pages[page.page_id]}
        {#each assessment.notepad[section.section_id].pages[page.page_id].notes as note (note._id)}
            <article class="media" class:is-hidden={hidden.has(note.note_id)}>
                <div class="media-content">
                    <div class="content">
                        <p class="is-size-6">
                            <strong>{$userMap[note.user] || note.user}</strong>
                            <small>
                                {formatTimestamp(note.ts)}

                                {#if $session.user.email == note.user}
                                    <span class="icon pointer" on:click={() => editNote(note)}>
                                        <i>✏️</i>
                                    </span>
                                {/if}
                            </small>
                            <span class="tags">
                                {#each note.tags || [] as tag}
                                    <span class="tag is-{tag.color_class}">{tag.name}</span>
                                {/each}
                            </span>
                            <span class="note">{@html clean(note.note)}</span>
                        </p>
                    </div>
                </div>
            </article>
        {/each}
        <hr>
    {/if}
    </div>

    <form on:submit|preventDefault={submitNote} bind:this={form}>
        {#if assessment.assessment_type_data.comment_tags}
            <NoteTags bind:value={tags} comment_tags={[...(assessment.assessment_type_data.comment_tags || []), ...assessment.comment_tags.tags]}></NoteTags>
        {/if}
        <div class="field">
            <div class="control">
                <TinyMCEField name="note" {mce_opts} on:submit={submitNote} showSubmitOnEnter />
                <!--<textarea class="textarea" name="note" on:keydown={handleEnter}></textarea>-->

                <span class="is-pulled-left is-size-7 markdown-help">
                    *<strong>bold</strong>* _<em>italics</em>_ ~<s>strikethrough</s>~ #<mark>highlight</mark>#
                </span>
            </div>
        </div>
        <div class="buttons is-right">
            <button class="button is-right">Save</button>
        </div>
    </form>
</div>

{#if showFormModal}
    <FormModal {...showFormModal}></FormModal>
{/if}

<style>
    .layout {
        height: 100%;
        width: 100%;
        display: grid;
        grid-template-rows: min-content auto min-content;
    }

    .tag.pointer {
        user-select: none;
    }
    .note {
        margin-top: .25rem;
    }

    .tags {
        margin-bottom: 0;
    }

    .notes {
        overflow: auto;
    }
</style>